module.exports = __webpack_public_path__ + "media/customizations/regencyatwaterset/back-bdc1c7062c9236103b5e0b60c5cbfce9.jpg";